<template>
  <div
    v-if="texto.blocks.length === 0"
    key="emptyNode"
  >
  </div>
  <div
    v-else
    key="fullNode"
    class="m-edition-asset-node"
  >
    <Block
      v-for="(block, index) in texto.blocks"
      :key="index"
      :is="`MoleculeContentNodeBlock${block.type}`"
      :block="block"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentNode',

  components: {
    MoleculeContentNodeBlockAudio: () => import('@/components/molecules/MoleculeContentNodeBlockAudio'),
    MoleculeContentNodeBlockDocument: () => import('@/components/molecules/MoleculeContentNodeBlockDocument'),
    MoleculeContentNodeBlockIframeVideo: () => import('@/components/molecules/MoleculeContentNodeBlockIframeVideo'),
    MoleculeContentNodeBlockImage: () => import('@/components/molecules/MoleculeContentNodeBlockImage'),
    MoleculeContentNodeBlockLink: () => import('@/components/molecules/MoleculeContentNodeBlockLink'),
    MoleculeContentNodeBlockParagraph: () => import('@/components/molecules/MoleculeContentNodeBlockParagraph'),
    MoleculeContentNodeBlockTitle1: () => import('@/components/molecules/MoleculeContentNodeBlockTitle1')
  },

  props: {
    isTask: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    texto () {
      if (this.isTask) {
        return this.$store.getters.getAssetSelectedTask.texto
          ? JSON.parse(this.$store.getters.getAssetSelectedTask.texto)
          : { blocks: [] }
      } else {
        return this.$store.getters.getAssetSelectedNode.texto
          ? JSON.parse(this.$store.getters.getAssetSelectedNode.texto)
          : { blocks: [] }
      }
    }
  }
}
</script>
